module.exports = __webpack_public_path__ + "static/media/icon-in-out.e469daca.svg";